

























































































































































import { SubEvent, EventExtraInfo, EventInfo, DateRange } from '@ssp/inscreva-sse-models';
import { DatePickerType } from '@ssp/ss-commons-front/src/components/DatePicker.vue';
import moment from 'moment';
import { Component, Vue, Prop, Emit } from 'vue-property-decorator';

import { TemplateOptions } from '../models/template';
import EventCardListItemFooter from './EventCardListItemFooter.vue';
import EventTimeline from './EventTimeline.vue';
import ImageSelect, { ImageSelectOptions } from './ImageSelect.vue';
import DynamicFormField from './inscreva-sse/DynamicFormField.vue';

@Component({
  components: {
    DynamicFormField,
    EventCardListItemFooter,
    ImageSelect,
    EventTimeline,
  },
})
export default class EventCardComponent extends Vue {
  @Prop({ required: true, type: SubEvent })
  private event!: SubEvent;

  @Prop({ required: true })
  private parentInfo!: EventExtraInfo & EventInfo;

  @Prop({ default: false })
  private isEditing: boolean;

  @Prop({
    default: () => ({
      title: 'Título',
      subTitle: 'Sub-Título',
    }),
  })
  private templateOptions: TemplateOptions;

  private imageOptions: ImageSelectOptions;

  created() {
    this.imageOptions = {
      title: `Imagem - ${this.templateOptions.title}`,
      imageSize: '300x275',
    };
  }

  @Emit()
  onFavorite() {
    this.event.favorite();
    return this.event;
  }

  @Emit()
  select() {
    return this.event;
  }

  decrease() {
    // decrease
  }

  increase() {
    // increase
  }

  @Emit()
  onEditImage({ imageBase64 }: { imageBase64: string }) {
    return { imageBase64 };
  }

  get show_date() {
    return !!this.event.info.date?.start && !!this.event.info.date?.end;
  }

  get show_place() {
    return !!this.event.info.place.name;
  }

  geTimelineType(finishDate: Date, startDate: Date): DatePickerType {
    const diffDays: number = moment(finishDate).date() - moment(startDate).date();
    return diffDays > 1 ? 'datetime' : 'time';
  }

  getSubscriptionTimelineType(): DatePickerType {
    return this.geTimelineType(new Date(this.event.info.date.end), new Date(this.event.info.date.start));
  }

  getEventTimelineType(): DatePickerType {
    return this.geTimelineType(
      new Date(this.event.info.subscription_date.end),
      new Date(this.event.info.subscription_date.start),
    );
  }

  onUpdateDates(dates: Array<DateRange>) {
    this.event.info.dates = dates;
    return this.onUpdateInfo();
  }

  @Emit()
  onUpdateInfo() {
    return this.event.info;
  }
}
